<div class="quantity-dialog-box-container">
    <div>
        <mat-label>Quantity</mat-label>
    </div>
    <div class="editQuantityDilog">
        <sp-custom-number-input
            [value]="variantsQuantity"
            (valueUpdateEvent)="updateQuantity($event)"
        ></sp-custom-number-input>
        <button
            mat-raised-button
            color="primary"
            class="quantity-button"
            class="editQuantityBtn"
            (click)="updateQuantityToVariants()"
        >
            Apply to {{ selectedCount }} Variants
        </button>
    </div>
</div>
